const publicPath = process.env.PUBLIC_PATH;
const batteryData = require('../../public/notificationAssets/battery/index.json');

export const data = [
  {
    id: 1,
    title: '小鹏汽车维修信息购买流程',
    content: `尊敬的用户，您好！<br/><br/>
    您可免费查看用户手册，如需查看维修手册、电路图等信息，请通过小鹏汽车APP扫下方二维码购买。如果您在使用过程中遇到问题，可以发送邮件至 <a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a>，感谢支持！<br/><br/>
    <div style="width: 100%;display: flex;align-items: center;justify-content: center;"><img src="${publicPath}/notificationAssets/qrcode.png"/></div>
    <br/><br/>使用流程：<br/>
1.登录注册小鹏汽车维修资料平台：<a href="https://sip.xiaopeng.com" target="_blank">https://sip.xiaopeng.com</a>。<br/>
2.发送兑换码和注册账户ID、手机号，以及付款凭证截图附件到管理员邮箱：<a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a><br/>
3.管理员依据验证码和订单信息开通账户查阅权限，并邮件反馈开通成功后即可正常查看。`,
    time: '2025-5-20',
    assets: []
  },
  {
    id: 2,
    title: '动力电池相关信息公示',
    content: '',
    time: '2025-7-10',
    assets: batteryData.map(item => ({
      ...item,
      url: `${publicPath}/notificationAssets/battery/pack/${item.url}`
    }))
  }
];

export const globalData = [
  // 原始文档：https://xiaopeng.feishu.cn/wiki/MDzmwJH6hiRQtLk5dSrcx5mNnqc
  {
    id: 4,
    title: 'Technical Information Reading Authority Purchase Notification',
    content: `<p>For guest accounts, you can just access to the user manual. If you want to look up other manual such as repair manual, circuit diagram, you have to purchase related authority first. The following is an introduction to the standard procedure.</p>
<br />
<p><strong>Step1</strong></p>
<h3>Commodity Price - Service Manual</h3>
<table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;text-align:center;width:50%;margin-bottom:20px;">
<tr>
  <th style="padding:8px;"></th>
  <th style="background-color:#f4f6f8;padding:8px;">24 HOURS</th>
  <th style="background-color:#f4f6f8;padding:8px;">30 DAYS</th>
  <th style="background-color:#f4f6f8;padding:8px;">365 DAYS</th>
</tr>
<tr>
  <td style="padding:8px;"><strong>EU (EUR)</strong></td>
  <td style="padding:8px;">€ 30</td>
  <td style="padding:8px;">€ 250</td>
  <td style="padding:8px;">€ 2500</td>
</tr>
</table>
<br />
<h3>Commodity Price - EPC/IVDS</h3>
<table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;text-align:center;width:70%;margin-bottom:20px;">
<tr>
  <th style="padding:8px;"></th>
  <th style="padding:8px;"></th>
  <th style="background-color:#f4f6f8;padding:8px;">24 HOURS</th>
  <th style="background-color:#f4f6f8;padding:8px;">7 DAYS</th>
  <th style="background-color:#f4f6f8;padding:8px;">30 DAYS</th>
  <th style="background-color:#f4f6f8;padding:8px;">365 DAYS</th>
</tr>
<tr>
  <td rowspan="2" style="padding:8px;"><strong>EU (EUR)</strong></td>
  <td style="background-color:#f4f6f8;padding:8px;">Spare parts inquiry</td>
  <td style="padding:8px;">€ 25</td>
  <td style="padding:8px;">/</td>
  <td style="padding:8px;">/</td>
  <td style="padding:8px;">€ 1500</td>
</tr>
<tr>
  <td style="background-color:#f4f6f8;padding:8px;">Diagnostic Tool</td>
  <td style="padding:8px;">€ 60</td>
  <td style="padding:8px;">€ 150</td>
  <td style="padding:8px;">/</td>
  <td style="padding:8px;">/</td>
</tr>
</table>
<br />
<p>1. Select the option you would like to subscribe to (Please be sure to inform us of the features you wish to subscribe to)</p>
<p>2. Share your company details and VAT number (We will issue you an invoice)</p>
<p>3. If you subscribe to Diagnostic Tool. Please be sure to follow the <strong>diagnostic tool guidelines</strong> in the announcement to ensure proper use of the diagnostic tools.</p>


<br />
<p><strong>Step2</strong></p>
<h3>Payment Method</h3>
<p>You can transfer money offline to the following account, transfer specific amount corresponding to the validity period you need to purchase. It is particularly important that you must note your email registered on the system website, and then send your purchasing information (including your email registered on the Service information website, too) to this email address:</p>
<p><a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a></p>
<p>Otherwise, we will not be able to identify your transaction and the purchase will be failed.</p>
<p><strong>Beneficiary/Account Name</strong>: XPeng European Holding B.V.</p>
<p><strong>Beneficiary Bank</strong>: BNP Paribas SA, Netherlands Branch</p>
<p><strong>Beneficiary bank address</strong>: Herengracht 595 - 1017 CE Amsterdam (The Netherlands) | PO Box 10042 - 1001 EA Amsterdam (The Netherlands)</p>
<p><strong>Account No. (IBAN)</strong>: NL82BNPA0227741676</p>
<p><strong>SWIFT CODE</strong>: BNPANL2A</p>
<br />
<p><strong>Step3</strong></p>
<h3>Permission Activation</h3>
<p>Your transaction should be issued within seven business days. We will activate your permission within 48 hours after receiving the transfer. Then, you will receive a notification email and be able to browse the documents.</p>
<p>The validity period of your permission will be calculated starting from the first time you log in to the Service information website after activation.</p>
<br />
<br />
<h2>SIP System User Guide</h2>
<video controls style="width:818px;" src="${publicPath}/notificationAssets/Technical-Information-Reading-Authority-Purchase-Notification/SIP-System-User-Guide.mp4"></video>
`,
    time: '2026-3-30',
    assets: []
  },
  // https://xiaopeng.feishu.cn/wiki/ZD9SwoGDPiHoCrkptv0ceto7nwg
  {
    id: 5,
    title: 'Diagnostic Tool Guideline',
    content: `<h2>1. How to Log in to the IVDS</h2>
  <p>The operating environment of the IVDS requires the vehicle to be in Check Mode. Therefore, before using the functions of the IVDS, the vehicle needs to first enter Check Mode.</p>

  <h3>1.1 How to Enter Check Mode</h3>
  <p>When entering Check mode, the vehicle system status is adjusted accordingly:</p>
  <ul>
  <li>Remote control of the vehicle by the shielded mobile app, unable to control the vehicle remotely (unlocking, opening windows, air conditioning, etc.), Disallow remote viewing and stop information push to avoid the risk of customer misbehavior leading to maintenance processes</li>
  <li>The inline platform identifies the vehicle as being in service during fault monitoring.</li>
  <li>Protect the user's personal privacy, the system automatically exit the customer account, account-related functions exit (music, navigation, etc.), Sentry mode stops triggering.</li>
  <li>The system shuts down the vehicle and delays the power down.</li>
  <li>Vehicle enters speed limit, speed limit 20km/h.</li>
  </ul>

  <h3><strong>Method:</strong> IVDS subscribers for <strong>7 DAYS</strong>. Join the service group via <strong>Lark (Feishu)</strong>, send the relevant account and vehicle model information, and the XPENG system administrator will assist in entering the Check Mode. (A 1-day subscription can be activated via email)</h3>

  <p><strong>Method of Lark installation: Download Lark via <a href="https://www.larksuite.com/en_sg/" target="_blank">https://www.larksuite.com/en_sg/</a>, after register, please provide us your account by email (<a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>), XPENG will provide you with exclusive 1-on-1 service.</strong></p>
  <p><strong>Instructions for Use:</strong> Recommended, requires network (4G or WIFI), can listen to online music or access other video websites, ensure the connection is normal.</p>

  <p><strong>Specific operations:</strong></p>
  <ol>
  <li><strong>Obtain basic vehicle information:</strong>
  <p>a. On the CID dial pad, enter <code>*#9925*111#*</code>, obtain the <strong>vehicle's basic information</strong>, and take a photo.</p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/dial-pad.png" style="height:400px;" />
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/vehicle-info.jpg" style="height:400px;" />
  </p>
  <p>b. Take photos of <strong>the entire vehicle</strong> and <strong>the VIN photo on the windshield</strong></p>
  <p><strong>The above photos need to ensure that they have the time watermark of the day when the information was sent.</strong></p>
  </li>
  <li>Join the Feishu service group and send the above three photos along with your paid account information to the XPeng system administrator for information verification.</li>
  <li>After the XPeng system administrator verifies OK, please keep the vehicle powered on and connected to the network. The XPeng system administrator will activate the vehicle's Check Mode Function.</li>
  <li>Confirm whether the vehicle's CID has entered the IVDS interface screen.
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/ivds-interface.png" style="height:400px;" />
  </p>
  </li>
  </ol>

  <h3>1.2 How to Enter the On-Board Diagnostic Interface</h3>
  <p>When a vehicle enters the Check Mode, the IVDS interface screen will automatically pop up. Click Turn on IVDS to enter it.</p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/turn-on-ivds.png" style="height:500px;" />
  </p>
  <p>After entering the IVDS, clicking the "X" in the upper right corner of it will return to the CID interface, but will not exit the Check mode. Before exiting the Check mode, you can repeatedly enter the IVDS interface screen through the "Magnifying Glass" icon of the IVDS at the top of the screen.</p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/magnifying-glass.png" style="height:300px;" />
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/ivds-top-icon.png" style="height:300px;" />
  </p>

  <h3>1.3 How to Update the IVDS</h3>
  <p>When the vehicle is connected to the network, <strong><u>please be sure to click the update button behind App Version and Script Version above to ensure that the functions are kept up to date</u></strong>.</p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/update-button.png" style="height:240px;" />
  </p>
  <p>If the update fails, please first confirm whether the CID network is normal. You can try connecting to Wi-Fi. If the issue still cannot be resolved, contact the service desk.</p>

  <h2>2. How to Exit the IVDS</h2>
  <h3>2.1 How to Exit Check Mode and the IVDS</h3>
  <p>The Check Mode and the IVDS will synchronously exit, and the Check Mode status on the CID and IVDS will also synchronously disappear; if you enter the Check Mode and the IVDS again, you need to follow the requirements of entering the check mode to execute.</p>

  <h4>2.2.1 Method: Manually exit the Check Mode and IVDS on the CID interface</h4>
  <p><strong>Instructions for Use:</strong> Recommended, requires network (4G or WIFI), can listen to online music or access other video websites, ensure the connection is normal.</p>
  <p><strong>Specific operations:</strong></p>
  <ol>
  <li>Click the IVDS icon at the top of the CID, <strong>before exiting, be sure to first cancel speed limit.</strong>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/cancel-speed-limit.png" style="height:370px;" />
  </p>
  </li>
  <li>Click the IVDS icon at the top of the CID, <strong>then operate the menu: Turn off Check Mode.</strong>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/turn-off-check-mode.png" style="height:370px;" />
  </p>
  </li>
  <li><strong>Test drive, confirm exiting Speed Limit, and confirm that the vehicle speed can reach above 21 km/h.</strong></li>
  </ol>

  <h4>2.2.2 Special Attention:</h4>
  <p>If the CID fails to exit the Inspection Mode, please power cycle the device or unlock/lock the vehicle and then power it on again, wait for more than 5 seconds, reconfirm that the network status is OK, and then retry the exit operation. If it fails 3 times, please contact <a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>.</p>

  <h2>3. Introduction to the Function of Cancel Speed Limit</h2>
  <p>When the vehicle is in Check Mode, it will enter speed-limited driving with a speed limit of 20 km/h. After exiting the Check Mode, the vehicle's Speed Limit will also be canceled.</p>
  <p>If a road test is required during the Maintenance Process or Vehicle Quality Inspection, the Speed Limit can be temporarily lifted. After the speed limit is lifted, the vehicle will be able to travel at full speed. When the vehicle is powered on again during the next power cycle, if it remains in the inspection mode, the vehicle will re-enter the Speed Limit, with the restricted speed still being 20 km/h.</p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/7f5e70247ed0.png" style="height:254px;" />
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/a7bf06cb0c2f.png" style="height:254px;" />
  </p>

  <h2 style="color:#d83931;">4. Reset Maintenance Interval Function requires notification (Forbidden!!!)</h2>
  <p style="color:#d83931;"><strong>This function is prohibited while using IVDS. We will pursue legal action for any consequences arising from this violation.</strong></p>
  <p style="text-align:center;">
    <img src="${publicPath}/notificationAssets/Diagnostic-Tool-Guideline/c423289f39d2.png" style="height:422px;" />
  </p>

  <h2>5. IVDS Usage Method</h2>
  <p>The usage requirements for the IVDS project should be carried out in accordance with the Service Manual.</p>

  <h2>6. Others</h2>
  <p>XPENG reserves the right to interpret terms and make improvements as needed.</p>`,
    time: '2026-3-30',
    assets: []
  },
  // 原始文档：https://xiaopeng.feishu.cn/docx/TbhqdKma3oYm4wxoeOxcSFIvnGE
  {
    id: 3,
    title: 'Alcohol Interlock Installation Guide Release',
    content: `<p>To be compliance with the laws and regulation in many markets, XPENG vehicles come with a reserved alcohol interlock connector to facilitate the alcohol interlock installation when needed.</p>
<p>To find out how to properly install an alcohol interlock, you may find the installation guide based on the vehicle model in the attached document below.</p>
<br />
<p>Give us feedback by email: <a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>, or through the feedback option in the right lower corner.</p>`,
    time: '2026-2-25',
    assets: [
      {
        name: 'Alcohol Interlock Installation Guide - P7.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-P7.pdf`
      },
      {
        name: 'Alcohol Interlock Installation Guide - G6.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-G6.pdf`
      },
      {
        name: 'Alcohol Interlock Installation Guide - G9.pdf',
        type: 'pdf',
        url: `${publicPath}/notificationAssets/Alcohol-Interlock-Installation-Guide-Release/Alcohol-Interlock-Installation-Guide-G9.pdf`
      }
    ]
  }
];
